import { render, staticRenderFns } from "./ModalStaffPlaygroundMessageList.vue?vue&type=template&id=b277f684&scoped=true&"
import script from "./ModalStaffPlaygroundMessageList.vue?vue&type=script&lang=ts&"
export * from "./ModalStaffPlaygroundMessageList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b277f684",
  null
  
)

export default component.exports